module.exports = __webpack_public_path__ + "media/new-request.c9830c32.mp3";